import { Box, Flex, Spacer, Divider, Text } from '@chakra-ui/react';
import { format } from 'date-fns';
import numeral from 'numeral';
import ArrowUpLeft from '../icons/ArrowUpLeft';
import ArrowDownRight from '../icons/ArrowDownRight';
import { Link } from 'react-router-dom';

const Transaction = ({
  description,
  createdAt,
  amount,
  type,
  id,
  border
}: {
  description: string;
  createdAt: string;
  amount: string;
  type: string;
  border?: boolean;
  id: string;
}) => {
  return (
    <Box as={Link} mt={2} display='block' to={`/transactions/${id}`}>
      <Flex columnGap={2.5}>
        <Box borderRadius='md' alignSelf='flex-start' p={1}>
          {type === 'debit' ? <ArrowUpLeft /> : <ArrowDownRight />}
        </Box>

        <Box width='full'>
          <Flex alignItems='center' justify='space-between' mb={3}>
            <Box>
              <Text fontSize='sm' fontWeight='bold' mb={0.5} color='#172554'>
                {description}
              </Text>
              <Text fontSize='xs' fontWeight='medium' color='#94a3b8'>
                {format(new Date(createdAt), "do MMM, yyyy 'at' p")}
              </Text>
            </Box>
            <Spacer />
            <Text
              fontSize='sm'
              fontWeight='bold'
              color={type === 'debit' ? '#16a34a' : '#1e40af'}
              mr={2}
            >
              Ksh. {numeral(amount).format('0,0')}
              <sup>{numeral(amount).format('.00')}</sup>
            </Text>
          </Flex>
          {border && <Divider />}
        </Box>
      </Flex>
    </Box>
  );
};

export default Transaction;
